// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).ready(function() {
  var work_id = $('#invoice_work_id').val();
  var client_id = $('#invoice_client_id').val();
  
  if( $('#invoice_client_id').html() != undefined ) {
    if(client_id !== undefined || client_id !== 0 || client_id !== '' ) {
      get_works(client_id, work_id);
    }
    if(work_id !== undefined || work_id !== 0 || client_id !== '' ) {
      get_items(work_id);
    }
  }
  
  $('#invoice_client_id').on('change', function() {
    client_id = $(this).val();
    $('#items').html('');
    get_works(client_id, work_id)
  })
  
  $('#invoice_work_id').on('change', function() {
    work_id = $(this).val()
    get_items(work_id);
  })
  
  $('#invoice_days_due').on('change', function() {
    calculate_date_due( $(this).val() );
  })
  
  
  
});

function get_items(work_id) {
  $.get('/works/' + work_id + '/get_items');
}

function get_works(client_id, work_id) {
  if(work_id) {
    $.get('/works/' + client_id + '/get_works?work_id=' + work_id);
  } else {
    $.get('/works/' + client_id + '/get_works'); 
  }
}

function calculate_date_due(days_due) {
  var due_date = new Date();
  var new_day; 
  
  new_day = parseInt(due_date.getDate()) + parseInt(days_due)
  due_date.setDate(new_day);
  
  $('#invoice_due_on').val( (due_date.getMonth() + 1) + '/' + due_date.getDate() + '/' + due_date.getFullYear() );
}